import { ApprovalFormFields } from "@/components/ApprovalForm/ApprovalForm";

/**
 * 检查当前节点是否匹配给定的节点代码列表
 * @param nodeCodes 节点代码列表
 * @param currentNodeCode 当前节点代码
 * @returns 如果当前节点代码在节点代码列表中，则返回 true；否则返回 false
 */
export function isMatch(nodeCodes: string[], currentNodeCode?: string) {
  if (!currentNodeCode) return false;
  return nodeCodes.some((code) => code === currentNodeCode);
}

/**
 * 解析审批类型为流程跳过类型
 * @param skipType 审批类型
 * @returns 流程跳过类型
 */
export function resolveSkipType(skipType: ApprovalFormFields["skipType"]) {
  return skipType === "REJECT" ? "" : "PASS";
}
